import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';

import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BookList from 'rebook/apps/books/components/BookList';
import CatalogHeader from 'rebook/apps/catalog/components/CatalogHeader';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import { Genre } from 'rebook/apps/catalog/models';
import EmptyFilterResult from 'rebook/apps/base/components/EmptyFilterResult';
import CatalogAsideMenu from 'rebook/apps/catalog/components/CatalogAsideMenu';
import * as GenreDetailActions from 'rebook/apps/catalog/actions/GenreDetailActions';
import CatalogFilter from 'rebook/apps/catalog/components/Filters/CatalogFilter';


import styles from './style.scss';


const paginateCountLong = 10;
const paginateCountShort = 18;
const AUDIO_BOOK_TYPE = 'audio';

class GenreDetailView extends React.Component {
  constructor() {
    super();
    this.state = {
      isDisplayLongVersion: false,
    };
  }

  static fetchInitialDataForServer(match, store) {
    const paginateBy = get(match, 'path', '').indexOf('/t/') !== -1 ? paginateCountLong : paginateCountShort;
    return store.dispatch(GenreDetailActions.fetchInitialData(match, {}, paginateBy));
  }

  componentDidMount() {
    const { match, location } = this.props;
    const paginateBy = get(match, 'path', '').indexOf('/t/') !== -1 ? paginateCountLong : paginateCountShort;
    this.props.GenreDetailActions.fetchInitialData(match, location, paginateBy);
    setTimeout(function () {
      window.dataLayer.push({ event: 'optimize.context.activate' });
    }, 0);
  }

  componentWillReceiveProps(nextProps) {
    const { genreSlug: newGenreSlug } = nextProps.match.params;
    const { genreSlug } = this.props.match.params;

    if (genreSlug !== newGenreSlug) {
      this.props.GenreDetailActions.resetData();
      this.props.GenreDetailActions.fetchInitialData(nextProps.match, nextProps.location);
    }
  }

  changePage(pageNumber) {
    window.scrollTo(0, 0);
    this.props.GenreDetailActions.fetchBookList({ pageNumber });
  }

  changeOrderBy(orderBy) {
    this.props.GenreDetailActions.fetchBookList({ orderBy });
  }

  filterBySubscriptionType(subscriptionId) {
    this.props.GenreDetailActions.fetchBookList({ subscriptionId });
  }

  changeBookType(bookType) {
    this.props.GenreDetailActions.fetchBookList({ bookType });
  }

  resetFilters() {
    this.props.GenreDetailActions.fetchBookList({
      subscriptionId: null,
      orderBy: 'popular',
      bookType: null,
    });
  }

  getCatalogAsideMenuItems(niche, genre) {
    if (!niche) {
      return [];
    }

    let items = [{
      ...niche,
      name: `Все книги в жанре<br> ${niche.name}`,
      active_book_count: get(niche, 'counters.books', 0),
      slug: `/catalog/${niche.slug}/books/`,
    },
    {
      ...niche,
      name: `Бесплатные книги в жанре<br> ${niche.name}`,
      active_book_count: get(niche, 'counters.free', 0),
      slug: `/catalog/${niche.slug}/books/free/`,
    },
    {
      ...niche,
      name: `Aудиокниги в жанре<br> ${niche.name}`,
      active_book_count: get(niche, 'counters.audio', 0),
      slug: `/catalog/${niche.slug}/books/audio/`,
    }];

    if (get(genre, 'counters.audio', 0) !== 0) {
      items.push({
        ...genre,
        name: `Все аудиокниги в жанре<br> ${genre.name}`,
        active_book_count: get(genre, 'counters.audio', 0),
        slug: `/catalog/${niche.slug}/${genre.slug}/books/audio/`,
      });
    }

    return items;
  }

  viewVersionToggler() {
    this.setState({ isDisplayLongVersion: !this.state.isDisplayLongVersion });
  }

  render() {
    const {
      genre: genreObject, books, pageNumber, lastPageNumber, orderBy, subscriptionId, similarGenres, bookType,
    } = this.props.genreDetail;
    const { match } = this.props;
    const isDisplayLongVersion = get(match, 'path', '').indexOf('/t/') !== -1;
    const { bookType: catalogBookType } = this.props.match.params;
    const genre = genreObject ? new Genre(genreObject) : null;
    const niche = get(genre, 'niche', null);
    const titlesMapper = {
      total: {
        header: `${get(genre, 'name', '')}`,
        breadCrumbs: get(genre, 'name', ''),
      },
      audio: {
        header: `Все аудиокниги в жанре «${get(genre, 'name', '')}»`,
        breadCrumbs: 'Все аудиокниги',
      },
    };
    const catalogAsideMenuItems = this.getCatalogAsideMenuItems(niche, genre);
    const isAudiobook = catalogBookType === AUDIO_BOOK_TYPE;

    return (
      <div className="section">
        <BreadCrumbs links={[
          { text: 'Библиотека', url: '/catalog/' },
          { text: get(niche, 'name', ''), url: `/catalog/${get(niche, 'slug', '')}/` },
          { text: get(genre, 'name', ''), url: genre ? genre.getLink() : '' },
          { text: isAudiobook ? titlesMapper.audio.breadCrumbs : '', url: '' },
        ]} />
        {genre
          ? (
            <CatalogHeader
              title={isAudiobook ? titlesMapper.audio.header : get(genre, 'name', '')}
              description={genre.seo_description || genre.description}
              bookCount={genre.active_book_count} />
          )
          : <CatalogHeader />
        }
        <div className={styles.content}>
          <div className={styles.contentAside}>
            <CatalogAsideMenu
              items={similarGenres}
              urlPattern={(slug) => (`/catalog/${get(niche, 'slug', '')}/${slug}/`)}
              passState />
            {niche &&
            <CatalogAsideMenu
              extraClassName={styles.allBooksLink}
              items={catalogAsideMenuItems}
              urlPattern={(slug) => (slug)} />
            }
          </div>
          <div className={styles.contentMain}>
            <div className={styles.filters}>
              <CatalogFilter
                orderBy={orderBy}
                subscriptionId={subscriptionId}
                bookType={bookType}
                isSubscriptionEnabled={!isAudiobook}
                isBookTypeEnabled={!isAudiobook}
                isResultEmpty={books && books.length === 0}
                onChangeSubscription={(value) => this.filterBySubscriptionType(value)}
                onChangeOrder={(value) => this.changeOrderBy(value)}
                onChangeBookType={((value) => this.changeBookType(value))}
                onResetFilter={() => this.resetFilters()} />
            </div>
            {
              !books
                ? <BookList books={[...Array(6)]} maxColumns={3} />
                : (isDisplayLongVersion ? <BookList books={books} maxColumns={1} isDisplayLongVersion /> :
                  <BookList books={books} maxColumns={3} />)
            }
            {books && books.length === 0 && <EmptyFilterResult />}
            {lastPageNumber > 1 && (
              <ContextPagination
                extraClassName={styles.pagination}
                onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
                currentPage={pageNumber}
                lastPage={lastPageNumber} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

GenreDetailView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      genreSlug: PropTypes.string.isRequired,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    genreDetail: state.genreDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    GenreDetailActions: bindActionCreators(GenreDetailActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GenreDetailView);
